<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading" class="flex-column flex-gap-30">

    <h1>{{getLabelValue('Title') | striphtml}}</h1>

    <div class="flex-column flex-gap-10">

        <div [innerHTML]="(complaintType === 1 ? getLabelValue('TextBox_1_DebtCollection') : getLabelValue('TextBox_1')) | safe: 'html'"></div>

        <div class="flex-row flex-gap-20">
            <button mat-raised-button class="flex-half yellow" (click)="attemptResolved = true">
                <span class="button-label">
                    <mat-icon *ngIf="attemptResolved === true" fontSet="material-icons-outlined">check_box</mat-icon>
                    <mat-icon *ngIf="attemptResolved !== true" fontSet="material-icons-outlined">check_box_outline_blank</mat-icon>
                    <span class="button-label-text" *ngIf="complaintType == 1">{{getLabelValue('ButtonYesDebtCollectionCompany') | striphtml}}</span>
                    <span class="button-label-text" *ngIf="complaintType !== 1">{{getLabelValue('ButtonYesCompany') | striphtml}}</span>
                </span>
            </button>

            <button mat-raised-button class="flex-half yellow" (click)="attemptResolved = false">
                <span class="button-label">
                    <mat-icon *ngIf="attemptResolved === false" fontSet="material-icons-outlined">check_box</mat-icon>
                    <mat-icon *ngIf="attemptResolved !== false" fontSet="material-icons-outlined">check_box_outline_blank</mat-icon>
                    <span class="button-label-text" *ngIf="complaintType == 1">{{getLabelValue('ButtonNoDebtCollectionCompany') | striphtml}}</span>
                    <span class="button-label-text" *ngIf="complaintType !== 1">{{getLabelValue('ButtonNoCompany') | striphtml}}</span>
                </span>
            </button>
        </div>

        <div class="info-text" *ngIf="!attemptResolved"
            [innerHTML]="(complaintType === 1 ? getLabelValue('Description_1_DebtCollection') : getLabelValue('Description_1')) | safe: 'html'">
        </div>
    </div>

    <div class="flex-column flex-gap-10">

        <div [innerHTML]="getLabelValue('TextBox_2') | safe: 'html'"></div>

        <div class="flex-row flex-gap-20">
            <button mat-raised-button class="flex-half yellow" (click)="attemptSettlement = true">
                <span class="button-label">
                    <mat-icon *ngIf="attemptSettlement === true" fontSet="material-icons-outlined">check_box</mat-icon>
                    <mat-icon *ngIf="attemptSettlement !== true" fontSet="material-icons-outlined">check_box_outline_blank</mat-icon>
                    <span class="button-label-text">{{getLabelValue('ButtonYesMan') | striphtml}}</span>
                </span>
            </button>

            <button mat-raised-button class="flex-half yellow" (click)="attemptSettlement = false">
                <span class="button-label">
                    <mat-icon *ngIf="attemptSettlement === false" fontSet="material-icons-outlined">check_box</mat-icon>
                    <mat-icon *ngIf="attemptSettlement !== false" fontSet="material-icons-outlined">check_box_outline_blank</mat-icon>
                    <span class="button-label-text">{{getLabelValue('ButtonNoMan') | striphtml}}</span>
                </span>
            </button>
        </div>

        <div class="info-text" *ngIf="attemptSettlement"
            [innerHTML]="(complaintType == 1 ? getLabelValue('Description_2_DebtCollection') : getLabelValue('Description_2')) | safe: 'html'">
        </div>
    </div>

    <div class="flex-column flex-gap-10">
        <div class="flex-row flex-gap-20">

            <button class="flex-half" mat-raised-button color="primary" (click)="navigateBack()">
                <span class="button-label">
                    <mat-icon>arrow_circle_left</mat-icon>
                    <span class="btn-label left">{{getLabelValue('ButtonGoBack') | striphtml}}</span>
                </span>
            </button>

            <button mat-raised-button color="primary" (click)="navigateForward()" class="flex-half reverse" [ngClass]="{'disabled': attemptResolved === undefined || attemptSettlement === undefined}">
                <span class="button-label">
                    <span class="btn-label left">{{getLabelValue('ButtonForward') | striphtml}}</span>
                    <mat-icon>arrow_circle_right</mat-icon>
                </span>
            </button>

        </div>
    </div>

</div>
